
window.addEventListener('load', (event) => {
  // POST MESSAGE ON WINDOW ONLOAD
  setTimeout(function() {
    postMessageToIFrame(tangent_iframe);
  }, 3000);
});

// Browser Back button Handling from browser cache
window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        const iframe = document.getElementById('tangent-block-quiz-iframe');
        iframe.src = iframe.src; // Reload the iframe by resetting its src
    }
});

const tangent_iframe = document.getElementById("tangent-block-quiz-iframe");
// POST MESSAGE ON IFRAME ONLOAD
tangent_iframe.addEventListener("load", function() {
  postMessageToIFrame(tangent_iframe);
});

function postMessageToIFrame(iframe){
  var iframe_window = iframe.contentWindow;

  // URL OF IFRAME LOAD CLIENT
  var url = window.location.href;

  // POST MESSAGE WITH URL
  var parent_url_params = encodeURIComponent(url);
  var parent_load_url = "tangent_client_url:"+parent_url_params;
  iframe_window.postMessage(parent_load_url, iframe.src);

  // POST MESSAGE WITH COOKIES
  var cookie_setting = "tangent_cookie:"+document.cookie;
  iframe_window.postMessage(cookie_setting, iframe.src);
}

function bindEvent(element, eventName, eventHandler) {
  if (element.addEventListener){
    element.addEventListener(eventName, eventHandler, false);
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler);
  }
}

bindEvent(window, 'message', function (e) {
  // Helper function to check if a string is valid JSON
  function isJsonString(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  // Function to handle the scroll to iframe logic
  function handleScrollToIframe(iframe, offset = 145) {
    const elementPosition = iframe.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  // Function to handle iframe height adjustment
  function adjustIframeHeight(iframe, newHeight) {
    const currentHeight = parseInt(iframe.style.minHeight, 10) || 0;

    if (!isNaN(newHeight) && newHeight !== currentHeight) {
      iframe.style.minHeight = `${newHeight}px`;
      iframe.style.width = "100%";
      iframe.style.display = "inline";
      handleScrollToIframe(tangent_iframe);
    }
  }

  // Main logic
  if (!isJsonString(e.data)) return;

  const obj = JSON.parse(e.data);

  if (obj.quiz_type === "inline" && obj.type === "page") {
    switch (obj.key) {
      case 'iframe-height':
        const heightBuffer = 50;
        const newHeight = parseInt(obj.value, 10) + heightBuffer;
        adjustIframeHeight(tangent_iframe, newHeight);
        break;

      default:
        // console.warn("Unhandled message key:", obj.key);
    }
  }
});